import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles.module.scss';
import { DAY_DISABLED, DAY_ENABLED, DAY_SELECTED } from './constants';

const DayReference = ({ day = {} }) => {
  const dayClassName = {
    [DAY_DISABLED]: styles.disabled,
    [DAY_ENABLED]: styles.enabled,
    [DAY_SELECTED]: styles.selected
  };

  return (
    <div className={styles.container} key={day.key}>
      <div className={`${styles.day} ${dayClassName[day.key]}`}>1</div>
      <UTLabel className={styles.label}>{day.label}</UTLabel>
    </div>
  );
};

DayReference.propTypes = {
  day: arrayOf(
    shape({
      key: string,
      label: string
    })
  )
};

export default DayReference;
